import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const ImageStrip = ({ images = [], className = '' }) => {
  const slots = Array.from({ length: 4 }, (_, i) => images?.[i] || null);

  return (
    <div className={`grid grid-cols-4 gap-2 ${className}`}>
      {slots.map((src, idx) => (
        <div
          key={idx}
          className="h-16 rounded-md border border-border bg-muted/30 overflow-hidden flex items-center justify-center"
        >
          {src ? (
            <Image
              src={src}
              alt={`Imagem do rolo ${idx + 1}`}
              className="w-full h-full object-cover"
            />
          ) : (
            <Icon name="Image" size={16} className="text-muted-foreground" />
          )}
        </div>
      ))}
    </div>
  );
};

export default ImageStrip;